import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const event = /*           */ asExport(o_util, "event", {});
const delegate = /*           */ asExport(event, "delegate", noop);
const stop = /*           */ asExport(event, "stop", noop);
const undelegate = /*           */ asExport(event, "undelegate", noop);
const on = /*           */ asExport(event, "on", noop);
const withEvents = /*           */ asExport(event, "withEvents", noop);
const unsetAll = /*           */ asExport(event, "unsetAll", noop);
const whichTransitionEndEvent = /*           */ asExport(
  event,
  "whichTransitionEndEvent",
  noop
);
export {
  delegate,
  event,
  on,
  stop,
  undelegate,
  unsetAll,
  whichTransitionEndEvent,
  withEvents
};
/*                                     */
